import React from 'react';
import {
  lightBlue500,
  grey300,
  white, darkBlack,
} from 'material-ui/styles/colors';
import muiThemeable from 'material-ui/styles/muiThemeable';

const styles = ({ palette }) => ({
  baseTab: {
    paddingBottom: 5,
    display: 'inline-block',
    textAlign: 'center',
    color: `${palette.textColor}`,
    cursor: 'pointer',
  },
  primary: {
    color: 'white',
  },
  white: {
    borderBottom: `2px solid ${palette.primary1Color}`,
  },
});

const sizeStyles = {
  big: {
    fontSize: 20,
    padding: '20px 30px',
  },
  medium: {
    fontSize: 14,
    padding: '0 30px 10px',
  },
  small: {
    fontSize: 12,
    padding: '10px 15px',
  },
};

const TabElement = ({
  primary,
  size = 'small',
  isActive,
  tabLabel,
  onTouchTap,
  muiTheme: { palette },
  borderStyle,
}) => {
  const primaryStyle = isActive ? {...styles({palette}).primary, borderBottom: `3px solid ${white}`, ...borderStyle } : styles({palette}).primary;
  const whiteStyle = isActive ? { ...styles({palette}).white, borderBottom: `2px solid ${darkBlack}` } : styles.white;
  return (
    <a
      style={{
        ...styles({ palette }).baseTab,
        ...primary ? primaryStyle : whiteStyle,
        ...sizeStyles[size],
      }}
      onClick={onTouchTap}
    >
      {tabLabel}
    </a>
  );
};

export default muiThemeable()(TabElement);



// WEBPACK FOOTER //
// ./src/components/Tabs/TabElement.js